"use strict";
// @ts-ignore
try {
    self['workbox:core:6.5.2'] && _();
}
catch (e) { }
